import * as React from 'react';
//import * as Select from 'react-select';
import {BaseComponent} from './BaseComponent';
import {ChiamaAPI, Trad} from './';
import {Link, NavLink} from 'react-router-dom';
import * as Dati from '../Dati';

export class BaseTabella extends BaseComponent<Dati.IBaseTabellaProps, {}> {
    protected _CSS: string = "kt_datatable kt-datatable kt-datatable--default kt-datatable--loaded";

    public constructor(props: any) {
        super(props);
        this.state = {}
        if (this.props.CSS != undefined)
            this._CSS += " " + this.props.CSS;
    }

    protected GetSfondoRiga(i: number): string {
        if (i % 2 == 0)
            return "kt-datatable__row kt-datatable__row--even";
        else
            return "kt-datatable__row kt-datatable__row";
    }

    //protected Sort(dati: any[], item: string, order: string) {
    //    dati.sort(function (a: any, b: any) {
    //        if (typeof a[item] === 'number' && typeof a[item] === 'number') {
    //            var valueA = a[item] === null ? 0 : a[item]; // ignore upper and lowercase
    //            var valueB = b[item] === null ? 0 : b[item]; // ignore upper and lowercase
    //            if (order == 'ASC')
    //                return valueA - valueB;
    //            else
    //                return valueB - valueA;
    //        } else {
    //            var valueOK: number;
    //            var valueKO: number;
    //            if (order == 'ASC') {
    //                valueOK = 1;
    //                valueKO = -1;
    //            }
    //            else {
    //                valueOK = -1;
    //                valueKO = 1;
    //            }
    //            var nameA = a[item] === null ? '' : a[item].toUpperCase(); // ignore upper and lowercase
    //            var nameB = b[item] === null ? '' : b[item].toUpperCase(); // ignore upper and lowercase
    //            if (nameA < nameB) {
    //                return valueKO;
    //            }
    //            if (nameA > nameB) {
    //                return valueOK;
    //            }

    //            // names must be equal
    //            return 0;
    //        }
    //    });
    //    this.forceUpdate();
    //}
}



// WEBPACK FOOTER //
// ./src/components/BaseTabella.tsx